module.exports = {
  "./packages/@react-spectrum/s2/chromatic/Accordion.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Accordion.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ActionButton.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ActionButton.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ActionButtonGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ActionButtonGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ActionMenu.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ActionMenu.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ActionMenuRTL.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ActionMenuRTL.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/AlertDialog.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/AlertDialog.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/AlertDialogRTL.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/AlertDialogRTL.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Avatar.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Avatar.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/AvatarGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/AvatarGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Badge.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Badge.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Breadcrumbs.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Breadcrumbs.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/BreadcrumbsRTL.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/BreadcrumbsRTL.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Button.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Button.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ButtonGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ButtonGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Card.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Card.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/CardView.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/CardView.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Checkbox.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Checkbox.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/CheckboxGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/CheckboxGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ColorArea.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ColorArea.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ColorField.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ColorField.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ColorSlider.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ColorSlider.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ColorSwatch.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ColorSwatch.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ColorSwatchPicker.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ColorSwatchPicker.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ColorWheel.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ColorWheel.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Combobox.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Combobox.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ComboboxRTL.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ComboboxRTL.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ContextualHelp.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ContextualHelp.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ContextualHelpRTL.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ContextualHelpRTL.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Dialog.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Dialog.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/DialogRTL.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/DialogRTL.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Disclosure.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Disclosure.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Divider.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Divider.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/DropZone.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/DropZone.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Forms.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Forms.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Icon.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Icon.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/IllustratedMessage.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/IllustratedMessage.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/InlineAlert.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/InlineAlert.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/LinkButton.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/LinkButton.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Menu.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Menu.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/MenuRTL.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/MenuRTL.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Meter.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Meter.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/NumberField.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/NumberField.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Picker.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Picker.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/PickerRTL.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/PickerRTL.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ProgressBar.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ProgressBar.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ProgressCircle.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ProgressCircle.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/RadioGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/RadioGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/RangeSlider.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/RangeSlider.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/SearchField.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/SearchField.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/SegmentedControl.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/SegmentedControl.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Slider.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Slider.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/StatusLight.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/StatusLight.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Switch.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Switch.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/TableView.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/TableView.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Tabs.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Tabs.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/TagGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/TagGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/TextField.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/TextField.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ToggleButton.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ToggleButton.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/ToggleButtonGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/ToggleButtonGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/Tooltip.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/Tooltip.stories.tsx"),

  "./packages/@react-spectrum/s2/chromatic/TooltipRTL.stories.tsx": () => import("../../../packages/@react-spectrum/s2/chromatic/TooltipRTL.stories.tsx"),

};
